import { render } from "./ConfirmationSection.vue?vue&type=template&id=70fde268&scoped=true"
import script from "./ConfirmationSection.vue?vue&type=script&lang=js"
export * from "./ConfirmationSection.vue?vue&type=script&lang=js"

import "./ConfirmationSection.vue?vue&type=style&index=0&id=70fde268&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fde268"]])

export default __exports__